import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCalendarDaysComponent } from "./med-icon-calendar-days.component";

@NgModule({
  declarations: [
    MedIconCalendarDaysComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCalendarDaysComponent,
  ],
})
export class MedIconCalendarDaysModule { }
